const defaultTotalState = {
  totalActivities: 0,
  totalAll: 0,
  totalFavorites: 0,
  totalTodo: 0,
  totalVisits: 0,
};

const defaultFilterState = {
  filterUsers: [],
  filterTags: [],
  filterTeams: [],
  filterScope: {},
};

export const defaultState = {
  channels: [],
  company: {
    locale: "pt-BR",
    company_teams: [],
  },
  contacts: [],
  isContactsLoading: false,
  searchContacts: [],
  credentials: [],
  leadSources: [],
  user: {
    role: "seller",
  },
  users: [],
  totals: {
    ...defaultTotalState,
  },
  whatsappOn: true,
  ...defaultTotalState,
  ...defaultFilterState,
};
